export default __webpack_public_path__ + "static/media/chatbotpage.b4746e5b.png";